import type { FieldMethod, FormFieldFactoryProps } from "../types/types";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const NotImplementedField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    return (
        <>
            {" "}
            <div> </div>
        </>
    );
};
